import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import NavigationBar from '@hydra/common/components/Header/NavigationBar';
import { TopNavigation } from '@hydra/common/components';
import { useUserContext } from '@hydra/common/context';

const useStyles = makeStyles(theme => ({
  root: { height: theme.mixins.toolbar.minHeight }
}));

interface HeaderProps {
  className?: string | undefined
  sideNavToggle?: React.MouseEventHandler<HTMLAnchorElement | HTMLDivElement> | undefined
}

function Header ({ sideNavToggle }: HeaderProps) {
  const classes = useStyles();
  const { user } = useUserContext();

  const isLoggedIn = !!(user && user.id);
  const HeaderComponent = isLoggedIn ? TopNavigation : NavigationBar;

  return (
    <div className={classes.root}>
      <HeaderComponent sideNavToggle={sideNavToggle} />
    </div>
  );
}

export default React.memo(Header);
